import React from 'react';
import { Card as BootstrapCard, CardBody } from 'react-bootstrap';
import { AlertTriangle, Camera, Clock, MapPin } from 'react-feather';
import { AiTwotoneSafetyCertificate } from "react-icons/ai";

const Card = ({ alert, isSelected = false, onSelect, onImageClick }) => {
  const getSeverityColor = (severity) => {
    switch (severity?.toLowerCase()) {
      case 'high':
        return '#dc3545';
      case 'medium':
        return '#ffc107';
      case 'low':
        return '#28a745';
      default:
        return '#6c757d';
    }
  };

  const handleCardClick = () => {
    if (onSelect) {
      onSelect(alert.id, !isSelected);
    }
  };

  const handleImageClick = (e) => {
    e.stopPropagation(); // Prevent card selection when clicking image
    if (onImageClick) {
      onImageClick(alert);
    }
  };

  return (
    <BootstrapCard 
      className="mb-3 shadow-sm" 
      style={{ 
        borderLeft: `4px solid ${isSelected ? '#28a745' : '#008ed3'}`, 
        overflow: 'hidden',
        cursor: onSelect ? 'pointer' : 'default',
        position: 'relative',
        opacity: isSelected ? 0.9 : 1,
        transform: isSelected ? 'scale(0.98)' : 'scale(1)',
        transition: 'all 0.2s ease'
      }}
      onClick={handleCardClick}
    >
      {/* Selection Indicator */}
      {isSelected && (
        <div
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            zIndex: 10,
            backgroundColor: '#28a745',
            color: 'white',
            borderRadius: '50%',
            width: '30px',
            height: '30px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '18px',
            fontWeight: 'bold',
            boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
          }}
        >
          ✓
        </div>
      )}

      {/* Image Section */}
      <div style={{ 
        width: '100%', 
        height: '180px', 
        overflow: 'hidden',
        backgroundColor: '#f8f9fa',
        position: 'relative',
        cursor: 'pointer'
      }}
      onClick={handleImageClick}
      >
        <img 
          src={alert.image} 
          alt={alert.alertType}
          style={{ 
            width: '100%', 
            height: '100%', 
            objectFit: 'cover',
            transition: 'transform 0.3s ease'
          }}
          onError={(e) => {
            e.target.src = 'https://via.placeholder.com/400x300?text=Alert+Image';
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = 'scale(1.05)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'scale(1)';
          }}
        />
        {isSelected && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(40, 167, 69, 0.2)',
              pointerEvents: 'none'
            }}
          />
        )}
      </div>

      <CardBody>
        <div className="d-flex justify-content-between align-items-start mb-2">
          <h7 className="mb-0 fw-bold" style={{textWrap:"nowrap"}}>Module: {alert.alertType}</h7>
        </div>
        
        <div className="d-flex flex-column gap-2 mt-3">
          <div className="d-flex align-items-center gap-2 text-muted">
            <Camera size={16} />
            <small><strong>Camera:</strong> {alert.cameraName}</small>
          </div>
          
          <div className="d-flex align-items-center gap-2 text-muted">
            <MapPin size={16} />
            <small><strong>Area:</strong> {alert.location}</small>
          </div>
          
          <div className="d-flex align-items-center gap-2 text-muted">
            <Clock size={16} />
            <small><strong>Time:</strong> {alert.timestamp}</small>
          </div>
          
          <div className="d-flex align-items-center gap-2 text-muted">
            <AiTwotoneSafetyCertificate  size={16}/>
            <small><strong>LSR:</strong> {alert.LSR}</small>
          </div>
        </div>
        
        <div className="mt-3 pt-2 border-top">
          <small className="text-muted">Reported by: <span className="fw-semibold">{alert.reportedBy}</span></small>
        </div>
      </CardBody>
    </BootstrapCard>
  );
};

export default Card;
